// extracted by mini-css-extract-plugin
module.exports = {"historyContainer":"History_historyContainer__1Ke7p","heading":"History_heading__eKtJj","container":"History_container__2ZBZk","noHistory":"History_noHistory__3jFxc"};